import { render } from "./SelecionarTipoEmissao.vue?vue&type=template&id=beb2a3e2&ts=true"
import script from "./SelecionarTipoEmissao.vue?vue&type=script&lang=ts"
export * from "./SelecionarTipoEmissao.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__